(ns manatee.spec.auth
  (:require [clojure.spec.alpha :as s]
            [clojure.string :as str]))

(s/def ::not-empty seq)
(s/def ::contains-at #(str/includes? % "@"))
(s/def ::contains-dot #(str/includes? % "."))

(s/def ::email
  (s/and ::not-empty
         ::contains-at
         ::contains-dot))

(s/def ::password (s/and ::not-empty)) ; see comment in src/shared/manatee/spec/core.cljc

(s/def ::login-form
  (s/keys :req-un [::email ::password]))
